import { render, staticRenderFns } from "./TodayFootfall.vue?vue&type=template&id=e77ab6dc&"
import script from "./TodayFootfall.vue?vue&type=script&lang=js&"
export * from "./TodayFootfall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports